import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SimpleBar from "simplebar-react";

//Import Components
import VerticalLayout from "./VerticalLayouts/index";
import TwoColumnLayout from "./TwoColumnLayout";
import { Container } from "reactstrap";
import HorizontalLayout from "./HorizontalLayout";

const Sidebar = ({ layoutType }) => {
  const domain = window.location.hostname;

  const [logos, setLogos] = useState(() => {
    try {
      const cachedData = localStorage.getItem(`custom_images_${domain}`);
      const cachedImages = cachedData ? JSON.parse(cachedData) : {};
      return {
        logoSm: cachedImages.smallLogo || null,
        logoDark: cachedImages.logo || null,
        logoLight: cachedImages.logoWhite || cachedImages.logo || null,
        logoWidth: cachedImages.logoSidebarWidth || 30,
        logoSmWidth: cachedImages.logoSidebarSmWidth || 35,
      };
    } catch {
      return {
        logoSm: null,
        logoDark: null,
        logoLight: null,
        logoWidth: 30,
        logoSmWidth: 35,
      };
    }
  });

  useEffect(() => {
    const updateLogos = () => {
      try {
        const cachedData = localStorage.getItem(`custom_images_${domain}`);
        const cachedImages = cachedData ? JSON.parse(cachedData) : {};

        const newLogos = {
          logoSm: cachedImages.smallLogo || null,
          logoDark: cachedImages.logo || null,
          logoLight: cachedImages.logoWhite || cachedImages.logo || null,
          logoWidth: cachedImages.logoSidebarWidth || 30,
          logoSmWidth: cachedImages.logoSidebarSmWidth || 35,
        };

        // Only update if we have logos
        if (newLogos.logoDark || newLogos.logoLight) {
          setLogos(newLogos);
        }
      } catch (error) {
        console.error('Erro ao carregar logos:', error);
      }
    };

    const interval = setInterval(updateLogos, 500);
    const timeout = setTimeout(() => clearInterval(interval), 5000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [domain]);

  useEffect(() => {
    var verticalOverlay = document.getElementsByClassName("vertical-overlay");
    if (verticalOverlay) {
      verticalOverlay[0].addEventListener("click", function () {
        document.body.classList.remove("vertical-sidebar-enable");
      });
    }
  });

  const addEventListenerOnSmHoverMenu = () => {
    // add listener Sidebar Hover icon on change layout from setting
    if (document.documentElement.getAttribute('data-sidebar-size') === 'sm-hover') {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover-active');
    } else if (document.documentElement.getAttribute('data-sidebar-size') === 'sm-hover-active') {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover');
    } else {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover');
    }
  };

  return (
    <React.Fragment>
      <div className="app-menu navbar-menu">
        <div className="navbar-brand-box">
          <Link to="/" className="logo logo-dark">
            <span className="logo-sm">
              {logos.logoSm && <img src={logos.logoSm} alt="" height={logos.logoSmWidth} />}
            </span>
            <span className="logo-lg">
              {logos.logoDark && <img src={logos.logoDark} alt="" height={logos.logoWidth} />}
            </span>
          </Link>

          <Link to="/" className="logo logo-light">
            <span className="logo-sm">
              {logos.logoSm && <img src={logos.logoSm} alt="" height={logos.logoSmWidth} />}
            </span>
            <span className="logo-lg">
              {logos.logoLight && <img src={logos.logoLight} alt="" height={logos.logoWidth} />}
            </span>
          </Link>
          <button
            onClick={addEventListenerOnSmHoverMenu}
            type="button"
            className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
            id="vertical-hover"
          >
            <i className="ri-record-circle-line"></i>
          </button>
        </div>
        {layoutType === "horizontal" ? (
          <div id="scrollbar">
            <Container fluid>
              <div id="two-column-menu"></div>
              <ul className="navbar-nav" id="navbar-nav">
                <HorizontalLayout />
              </ul>
            </Container>
          </div>
        ) : layoutType === 'twocolumn' ? (
          <React.Fragment>
            <TwoColumnLayout layoutType={layoutType} />
            <div className="sidebar-background"></div>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <SimpleBar id="scrollbar" className="h-100">
              <Container fluid>
                <div id="two-column-menu"></div>
                <ul className="navbar-nav" id="navbar-nav">
                  <VerticalLayout layoutType={layoutType} />
                </ul>
              </Container>
            </SimpleBar>
            <div className="sidebar-background"></div>
          </React.Fragment>
        )}
      </div>
      <div className="vertical-overlay"></div>
    </React.Fragment>
  );
};

export default Sidebar;
